class CloudCartDrawer extends HTMLElement {
  constructor() {
    super();
    this.activeElement = null;
    this.onDocumentKeydown = this.onDocumentKeydown.bind(this);
    this.onDocumentClick = this.onDocumentClick.bind(this);
    this.onDrawerClick = this.onDrawerClick.bind(this);
  }

  connectedCallback() {
    document.addEventListener('click', this.onDocumentClick);
    this.addEventListener('click', this.onDrawerClick);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.onDocumentClick);
    document.removeEventListener('keydown', this.onDocumentKeydown);
    this.removeEventListener('click', this.onDrawerClick);
  }

  onDocumentClick(event) {
    const trigger = event.target.closest('[data-cart-drawer-trigger]');
    if (!trigger) return;
    event.preventDefault();
    this.open(trigger);
  }

  onDrawerClick(event) {
    const closeButton = event.target.closest('[data-cart-drawer-close]');
    if (closeButton) {
      event.preventDefault();
      this.close();
      return;
    }

    const removeButton = event.target.closest('[data-cart-remove]');
    if (removeButton) {
      event.preventDefault();
      this.changeQuantity(removeButton.dataset.lineKey, 0);
      return;
    }

    const quantityButton = event.target.closest('[data-cart-quantity]');
    if (quantityButton) {
      event.preventDefault();
      const quantity = Math.max(0, Number(quantityButton.dataset.quantity));
      this.changeQuantity(quantityButton.dataset.lineKey, quantity);
    }
  }

  async open(trigger) {
    this.activeElement = trigger || document.activeElement;
    this.classList.add('active');
    this.querySelector('.cloud-cart-drawer__panel')?.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cloud-cart-open');
    document.addEventListener('keydown', this.onDocumentKeydown);
    await this.refresh();
    this.querySelector('.cloud-cart-drawer__close')?.focus();
  }

  close() {
    this.classList.remove('active');
    this.querySelector('.cloud-cart-drawer__panel')?.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cloud-cart-open');
    document.removeEventListener('keydown', this.onDocumentKeydown);
    if (this.activeElement && typeof this.activeElement.focus === 'function') this.activeElement.focus();
  }

  onDocumentKeydown(event) {
    if (event.key === 'Escape') {
      this.close();
      return;
    }

    if (event.key !== 'Tab') return;
    const focusable = [...this.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )].filter((element) => element.offsetParent !== null);
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  async changeQuantity(lineKey, quantity) {
    if (!lineKey || this.classList.contains('loading')) return;
    this.setLoading(true, 'Updating cart');

    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ id: lineKey, quantity })
      });

      const cart = await response.json();
      if (!response.ok) throw new Error(cart.description || cart.message || 'Failed to update cart');

      this.updateCount(cart.item_count);
      await this.refresh();
      this.announce(quantity === 0 ? 'Item removed' : 'Cart updated');
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
    } catch (error) {
      this.announce(error.message || 'Failed to update cart');
    } finally {
      this.setLoading(false);
    }
  }

  async refresh() {
    try {
      const separator = window.location.search ? '&' : '?';
      const response = await fetch(`${window.location.pathname}${window.location.search}${separator}section_id=cloud-cart-drawer`);
      if (!response.ok) return;

      const html = await response.text();
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const freshDrawer = parsed.querySelector('cloud-cart-drawer');
      if (!freshDrawer) return;

      const wasActive = this.classList.contains('active');
      this.innerHTML = freshDrawer.innerHTML;
      this.classList.toggle('is-empty', freshDrawer.classList.contains('is-empty'));
      if (wasActive) {
        this.classList.add('active');
        this.querySelector('.cloud-cart-drawer__panel')?.setAttribute('aria-hidden', 'false');
      }
    } catch (error) {
      this.announce('Failed to load cart, please try again');
    }
  }

  updateCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach((badge) => {
      badge.textContent = count;
      badge.classList.toggle('is-empty', count === 0);
    });
  }

  announce(message) {
    const status = this.querySelector('[data-cart-status]');
    if (!status) return;
    status.textContent = '';
    window.requestAnimationFrame(() => {
      status.textContent = message;
    });
  }

  setLoading(loading, message = '') {
    this.classList.toggle('loading', loading);
    if (message) this.announce(message);
  }
}

if (!customElements.get('cloud-cart-drawer')) {
  customElements.define('cloud-cart-drawer', CloudCartDrawer);
}

// Add to Cart 拦截：飞入动画 + 数量更新，不弹抽屉不跳转
document.addEventListener('submit', function(e) {
  const form = e.target.closest('#AddToCartForm');
  if (!form) return;
  e.preventDefault();

  // cloud-bed：刻字验证
  const engravingSelected = Array.from(document.querySelectorAll('.variant-option-button.engraving-option.checked-active')).some(el => el.textContent.includes('Add Hand Engraving'));
  if (engravingSelected) {
    const engraveInput = document.getElementById('variant_engraveInput');
    if (engraveInput && engraveInput.value.trim() === '') {
      engraveInput.style.border = '2px solid #e53e3e';
      engraveInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
      let tip = document.getElementById('engrave-required-tip');
      if (!tip) {
        tip = document.createElement('p');
tip.id = 'engrave-required-tip';
tip.textContent = 'Please enter your engraving text to continue.';
tip.style.cssText = 'color:#e53e3e; font-size:13px; margin-top:6px; display:block;';
engraveInput.closest('.skt-product_engraving') 
  ? engraveInput.closest('.skt-product_engraving').insertAdjacentElement('afterend', tip)
  : engraveInput.parentElement.insertAdjacentElement('afterend', tip);



      }
      return;
    } else if (engraveInput) {
      engraveInput.style.border = '';
      const tip = document.getElementById('engrave-required-tip');
      if (tip) tip.remove();
    }
  }

  // necklace：图片上传验证
  const uploader = document.getElementById('proxyUploaderImage');
  if (uploader) {
    const previewImgs = uploader.querySelectorAll('.preview-imgs img');
    if (previewImgs.length === 0) {
      uploader.style.border = '2px solid #e53e3e';
      uploader.scrollIntoView({ behavior: 'smooth', block: 'center' });
      let tip = document.getElementById('upload-required-tip');
      if (!tip) {
        tip = document.createElement('p');
        tip.id = 'upload-required-tip';
        tip.textContent = 'Please upload a photo to continue.';
        tip.style.cssText = 'color:#e53e3e; font-size:13px; margin-top:6px;';
        uploader.insertAdjacentElement('afterend', tip);
      }
      return;
    }
  }

  const formData = new FormData(form);

  fetch('/cart/add.js', {
    method: 'POST',
    body: formData
  })
  .then(res => res.json())
  .then(() => fetch('/cart.js'))
  .then(res => res.json())
  .then(cart => {
    document.querySelectorAll('[data-cart-count]').forEach(badge => {
      badge.textContent = cart.item_count;
      badge.classList.toggle('is-empty', cart.item_count === 0);
    });

    const btn = form.querySelector('#AddToCart');
    const badge = document.querySelector('[data-cart-count]');
    if (btn && badge) {
      const btnRect = btn.getBoundingClientRect();
      const badgeRect = badge.getBoundingClientRect();
      const fly = document.createElement('span');
      fly.textContent = '+1';
      fly.style.cssText = `
        position: fixed;
        left: ${btnRect.left + btnRect.width / 2}px;
        top: ${btnRect.top + btnRect.height / 2}px;
        color: #fff;
        background: #8C9080;
        border-radius: 50%;
        width: 28px;
        height: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        font-weight: 600;
        pointer-events: none;
        z-index: 9999;
        transition: all 0.7s cubic-bezier(0.25, 0.46, 0.45, 0.94);
      `;
      document.body.appendChild(fly);
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          fly.style.left = `${badgeRect.left + badgeRect.width / 2}px`;
          fly.style.top = `${badgeRect.top + badgeRect.height / 2}px`;
          fly.style.opacity = '0';
          fly.style.transform = 'scale(0.3)';
        });
      });
      setTimeout(() => fly.remove(), 800);
    }
  })
  .catch(err => console.error('Add to cart error:', err));
});




